<article>
  @if (!loadingService.loading$) {
    <div class="flex flex-row justify-end">
      <button mat-icon-button data-testid="closeResume" (click)="close()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }

  <div>
    <app-sous-titre-bloc>
      {{ 'components.dialogResumeGame.possession' | transloco }}
    </app-sous-titre-bloc>
    <app-button-toggle-group>
      <mat-button-toggle-group aria-label="possession" class="flex flex-col sm:flex-row w-full">
        <mat-button-toggle
          data-testid="possessionForHome"
          [checked]="odk === ODK.Offensive"
          (click)="setHome()" class="sm-pad toggle-btn w-full sm:w-1/2">
          <div class="equipe">
            <div class="info">{{ 'scoreBoard.home' | transloco }}</div>
            {{ game.game.homeTeam.teamShortName }}
          </div>
        </mat-button-toggle>
        <mat-button-toggle
          [checked]="odk === ODK.Defensive"
          data-testid="possessionForAway"
          (click)="setAway()" class="sm-pad toggle-btn w-full sm:w-1/2">
          <div class="equipe">
            <div class="info">{{ 'scoreBoard.away' | transloco }}</div>
            {{ game.game.awayTeam.teamShortName }}
          </div>
        </mat-button-toggle>
      </mat-button-toggle-group>
    </app-button-toggle-group>
  </div>

  <div class="flex flex-row flex-wrap">
    <div class="w-full flex justify-center items-start">
      <div class="flex flex-col flex-wrap w-full h-full">
        <div class="flex justify-start">

          <app-sous-titre-bloc>
            {{ 'scoreBoard.quarter' | transloco }}
          </app-sous-titre-bloc>

        </div>
        <div>
          <app-button-toggle-group>
            <mat-button-toggle-group aria-label="quarter" class="full-width">
              <mat-button-toggle
                data-testid="quarter1"
                [checked]="getLastQuarter() === 1"
                (click)="setQuarter(1)" class="sm-pad toggle-btn basis-1/4">
                {{ 'scoreBoard.1st' | transloco }}
              </mat-button-toggle>
              <mat-button-toggle
                data-testid="quarter2"
                [checked]="getLastQuarter() === 2"
                (click)="setQuarter(2)" class="sm-pad toggle-btn basis-1/4">
                {{ 'scoreBoard.2nd' | transloco }}
              </mat-button-toggle>
              <mat-button-toggle
                data-testid="quarter3"
                [checked]="getLastQuarter() === 3"
                (click)="setQuarter(3)" class="sm-pad toggle-btn basis-1/4">
                {{ 'scoreBoard.3rd' | transloco }}
              </mat-button-toggle>
              <mat-button-toggle
                data-testid="quarter4"
                [checked]="getLastQuarter() === 4"
                (click)="setQuarter(4)" class="sm-pad toggle-btn basis-1/4">
                {{ 'scoreBoard.4th' | transloco }}
              </mat-button-toggle>
              <mat-button-toggle
                data-testid="quarter5"
                [checked]="getLastQuarter() === 5"
                (click)="setQuarter(5)" class="sm-pad toggle-btn basis-1/4">
                {{ 'scoreBoard.OT' | transloco }}
              </mat-button-toggle>
            </mat-button-toggle-group>
          </app-button-toggle-group>
        </div>
      </div>
    </div>

    <div class="w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 flex justify-center items-start">
      <div class="flex flex-col flex-wrap w-full h-full">
        <app-sous-titre-bloc>
          {{ 'components.currentAction.down' | transloco }}
        </app-sous-titre-bloc>
        <app-button-toggle-group>
          <mat-button-toggle-group aria-label="down" class="full-width">
            <mat-button-toggle
              data-testid="down1"
              [checked]="down === Down.D1"
              (click)="setDown(Down.D1)" class="sm-pad toggle-btn" [ngClass]="game.getNumberOfDowns() === 4 ? 'basis-1/4' : 'basis-1/3'">
              {{ 'components.selectDown.1st' | transloco }}
            </mat-button-toggle>
            <mat-button-toggle
              data-testid="down2"
              [checked]="down === Down.D2"
              (click)="setDown(Down.D2)" class="sm-pad toggle-btn" [ngClass]="game.getNumberOfDowns() === 4 ? 'basis-1/4' : 'basis-1/3'">
              {{ 'components.selectDown.2nd' | transloco }}
            </mat-button-toggle>
            <mat-button-toggle
              data-testid="down3"
              [checked]="down === Down.D3"
              (click)="setDown(Down.D3)" class="sm-pad toggle-btn" [ngClass]="game.getNumberOfDowns() === 4 ? 'basis-1/4' : 'basis-1/3'">
              {{ 'components.selectDown.3rd' | transloco }}
            </mat-button-toggle>
            @if (game.getNumberOfDowns() === 4) {
              <mat-button-toggle
                data-testid="down4"
                [checked]="down === Down.D4"
                (click)="setDown(Down.D4)" class="sm-pad toggle-btn basis-1/4">
                {{ 'components.selectDown.4th' | transloco }}
              </mat-button-toggle>
            }
          </mat-button-toggle-group>
        </app-button-toggle-group>

        <app-select-hash
          [initialHash]="getLastHash()"
        (changeHash)="onChangeHash($event)" class="full-width"></app-select-hash>
      </div>
    </div>

    <div class="w-full sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/2 flex justify-center sm-pad-lf">
      <app-bloc-wheel>
        <app-select-yard-line
          #distanceToGoSelector
          [homeHasPossession]="game.homeHasPossession()"
          data-testid="distance"
          yardLinesToDisplay="simple"
          titlePrefix="{{ 'components.currentAction.distance' | transloco }}"
          [currentYard]="getLastDistance()"
          (yardLineChange)="onDistanceChange($event)"
        ></app-select-yard-line>
        <app-select-yard-line
          #spotTheBallSelector
          [homeTeamName]="game.game.homeTeam.teamNameAbr || ''"
          [awayTeamName]="game.game.awayTeam.teamNameAbr || ''"
          [homeHasPossession]="odk === ODK.Offensive"
          data-testid="spotTheBall"
          yardLinesToDisplay="default"
          titlePrefix="{{ 'components.dialogResumeGame.spotTheBall' | transloco }}"
          [currentYard]="getLastYardLine()"
          (yardLineChange)="onSpotBallChange($event)"
        ></app-select-yard-line>
      </app-bloc-wheel>
    </div>
  </div>

  <button data-testid="finishResume" class="finish-tag-btn" (click)="saveGamePlay()">
    {{ 'components.dialogResumeGame.save' | transloco }}
  </button>

</article>

